module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "bdialog"
    }
  }, [_c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gDia",
    attrs: {
      "title": _vm.config.edit ? _vm.$t('app_editver') : _vm.$t('app_addver')
    },
    on: {
      "close": _vm.verClose
    },
    model: {
      value: (_vm.isNewVer),
      callback: function($$v) {
        _vm.isNewVer = $$v
      },
      expression: "isNewVer"
    }
  }, [_c('div', [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label-width": _vm.widthps,
      "label": _vm.$t('app_version')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.vform.ver),
      callback: function($$v) {
        _vm.$set(_vm.vform, "ver", $$v)
      },
      expression: "vform.ver"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": _vm.widthps,
      "label": _vm.$t('app_pubdate')
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "format": _vm.yyyy - _vm.MM - _vm.dd,
      "picker-options": _vm.pickerOptions0,
      "placeholder": _vm.$t('app_select')
    },
    model: {
      value: (_vm.vform.date),
      callback: function($$v) {
        _vm.$set(_vm.vform, "date", $$v)
      },
      expression: "vform.date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": _vm.widthps,
      "label": _vm.$t('app_updct')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.vform.content),
      callback: function($$v) {
        _vm.$set(_vm.vform, "content", $$v)
      },
      expression: "vform.content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.verClose
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitVer()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gDia",
    attrs: {
      "title": _vm.config.edit ? _vm.$t('app_editblt') : _vm.$t('app_addblt')
    },
    on: {
      "close": _vm.bltClose
    },
    model: {
      value: (_vm.isNewBlt),
      callback: function($$v) {
        _vm.isNewBlt = $$v
      },
      expression: "isNewBlt"
    }
  }, [_c('div', [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label-width": _vm.widthps,
      "label": _vm.$t('app_blttt')
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.bform.title),
      callback: function($$v) {
        _vm.$set(_vm.bform, "title", $$v)
      },
      expression: "bform.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": _vm.widthps,
      "label": _vm.$t('app_bltct')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 7
    },
    model: {
      value: (_vm.bform.content),
      callback: function($$v) {
        _vm.$set(_vm.bform, "content", $$v)
      },
      expression: "bform.content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.bltClose
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitBlt()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.getPre() + _vm.info.title,
      "visible": _vm.isView,
      "size": "small",
      "before-close": _vm.viewClose
    },
    on: {
      "update:visible": function($event) {
        _vm.isView = $event
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "markdownBody"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.info.content)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.viewClose
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a91b17fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bulletin/bdialog.vue
// module id = 1111
// module chunks = 0